import axios from "axios";
import { getToken } from "utils/token";


const deleteCoupon = async (payload: any) => {
    const { data } = await axios.delete(`coupons/${payload?.couponId}`, {
        headers: { Authorization: getToken() },
    });

    return data;
};

export default deleteCoupon;
